import { Controller } from "@hotwired/stimulus";
import * as Turbo from "@hotwired/turbo";

export default class extends Controller {
  static targets = ["sentinel"];
  static values = {
    url: String,
    loading: { type: Boolean, default: false },
  };

  connect() {
    this.observer = new IntersectionObserver(
      (entries) => this.handleIntersect(entries),
      { rootMargin: "100px" }
    );
    if (this.hasSentinelTarget) {
      this.observer.observe(this.sentinelTarget);
    }
  }

  disconnect() {
    this.observer?.disconnect();
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !this.loadingValue) {
        this.loadMore();
      }
    });
  }

  async loadMore() {
    if (!this.urlValue) return;

    this.loadingValue = true;
    this.showLoadingIndicator();

    try {
      const response = await fetch(this.urlValue, {
        headers: {
          Accept: "text/vnd.turbo-stream.html",
          "X-Requested-With": "XMLHttpRequest",
        },
      });

      if (response.ok) {
        const html = await response.text();
        Turbo.renderStreamMessage(html);
      }
    } catch (error) {
      console.error("Error loading more items:", error);
    } finally {
      this.loadingValue = false;
      this.hideLoadingIndicator();
    }
  }

  showLoadingIndicator() {
    if (this.hasSentinelTarget) {
      this.sentinelTarget.innerHTML = `
        <div class="flex justify-center py-4">
          <svg class="animate-spin h-5 w-5 text-content-muted" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        </div>
      `;
    }
  }

  hideLoadingIndicator() {
    if (this.hasSentinelTarget) {
      this.sentinelTarget.innerHTML = "";
    }
  }
}
